import { useLayoutEffect } from 'react';
import {
  getEffectiveA11yPreferences,
  useA11yPreferencesStore,
} from '@/stores/a11y-preferences-store';

function applyA11yPreferences() {
  const prefs = getEffectiveA11yPreferences(useA11yPreferencesStore.getState().manual);
  const root = document.documentElement;
  const zoom = prefs.adaptFontToZoom ? prefs.fontSizePercent : prefs.zoomPercent;
  root.style.fontSize = `${prefs.fontSizePercent}%`;
  root.style.zoom = zoom === 100 ? '' : `${zoom / 100}`;

  root.classList.toggle('a11y-high-contrast', prefs.highContrast);
  root.classList.toggle('a11y-monochrome', prefs.monochrome);
  root.classList.toggle('a11y-reduce-motion', prefs.reducedMotion === 'on');
  root.classList.toggle('a11y-focus-emphasis', prefs.focusRingEmphasis);
  root.classList.toggle('a11y-emphasize-focus', prefs.focusRingEmphasis);
  root.classList.toggle('a11y-underline-links', prefs.underlineLinks);
  root.classList.toggle('a11y-toggle-labels', prefs.toggleOnOffLabels);
  root.classList.toggle('a11y-required-red', prefs.requiredFieldsRed);
  root.classList.toggle('a11y-strikethrough-disabled', prefs.strikethroughDisabled);
  root.classList.toggle('a11y-dyslexia-font', prefs.dyslexiaFont);
  root.classList.toggle('a11y-large-cursor', prefs.customCursor);
  root.classList.toggle('a11y-large-scrollbar', prefs.customScrollbar);
  root.classList.toggle('a11y-highlight-critical', prefs.highlightCritical);
  root.classList.toggle('a11y-picklist-subtle', prefs.picklistStyle === 'subtle');
  root.classList.toggle('a11y-picklist-minimal', prefs.picklistStyle === 'minimal');

  root.dataset.a11yReducedMotion = prefs.reducedMotion;
  root.dataset.a11yRequiredField = prefs.requiredFieldStyle;
  root.dataset.a11yLayout = prefs.displayLayout;
  root.dataset.a11yReadingMask = prefs.readingMask ? 'on' : 'off';
}

/**
 * Applies persisted accessibility preferences to `<html>` (font scale, contrast, motion).
 */
export function AccessibilityPreferencesSync() {
  const manual = useA11yPreferencesStore((s) => s.manual);

  useLayoutEffect(() => {
    const unsubFinish = useA11yPreferencesStore.persist.onFinishHydration(() => {
      applyA11yPreferences();
    });
    if (useA11yPreferencesStore.persist.hasHydrated()) {
      applyA11yPreferences();
    }
    return () => {
      unsubFinish();
    };
  }, []);

  useLayoutEffect(() => {
    if (!useA11yPreferencesStore.persist.hasHydrated()) return;
    applyA11yPreferences();
  }, [manual]);

  return null;
}
